import React from 'react';
import { ProfilePictureManager } from './ProfilePictureManager';
import './ProfileManager.css';

interface ProfileManagerProps {
  onFileUpload: (files: FileList) => void;
  onProfilePictureUpdate?: (pictureUrl: string | null) => void;
  onProfileDelete?: () => void;
}

const ProfileManager: React.FC<ProfileManagerProps> = ({
  onFileUpload,
  onProfilePictureUpdate,
  onProfileDelete
}) => {
  return (
    <div className="cv-manager">
      {/* Profile Picture Section */}
      <div className="sidebar-section">
        <ProfilePictureManager 
          onPictureUpdate={(pictureUrl) => {
            // Pass the picture URL up to the parent
            onProfilePictureUpdate?.(pictureUrl);
          }}
        />
      </div>

      {/* Upload Section */}
      <div className="sidebar-section">
        <div className="section-title">
          <span className="material-icons">cloud_upload</span>
          Upload Your Profile
        </div>
        <div
          className="upload-area"
          onDrop={(e) => {
            e.preventDefault();
            onFileUpload(e.dataTransfer.files);
          }}
          onDragOver={(e) => e.preventDefault()}
          onClick={() => document.getElementById('file-input')?.click()}
        >
          <div className="upload-icon">
            <span className="material-icons">upload_file</span>
          </div>
          <div className="upload-text">Drop your own PDF or DOCX profile here</div>
          <button className="upload-button">Choose File</button>
        </div>
        <input
          id="file-input"
          type="file"
          accept=".pdf,.docx"
          style={{ display: 'none' }}
          onChange={(e) => e.target.files && onFileUpload(e.target.files)}
        />
        {/* SharePoint button hidden for now
        <div style={{ marginTop: '16px' }}>
          <button className="btn" style={{ width: '100%', justifyContent: 'center' }}>
            <span className="material-icons">cloud</span>
            Browse SharePoint
          </button>
        </div>
        */}
      </div>

      {/* Current Profile Status - Simplified */}
      <div className="sidebar-section">
        <div className="section-title" style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
            <span className="material-icons">person</span>
            Your Profile
          </div>
          <button
            onClick={() => {
              if (window.confirm('Are you sure you want to delete your own profile? This will remove all your profile data from Azure.')) {
                onProfileDelete?.();
              }
            }}
            style={{
              background: 'transparent',
              border: 'none',
              cursor: 'pointer',
              padding: '4px',
              borderRadius: '4px',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              transition: 'background-color 0.2s',
              color: '#dc3545'
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.backgroundColor = 'rgba(220, 53, 69, 0.1)';
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.backgroundColor = 'transparent';
            }}
            title="Delete Profile"
          >
            <span className="material-icons" style={{ fontSize: '18px' }}>delete</span>
          </button>
        </div>
        <div className="profile-status">
          <div style={{
            textAlign: 'center',
            padding: '24px',
            color: 'rgba(255, 255, 255, 0.5)'
          }}>
            <span className="material-icons" style={{ fontSize: '48px', opacity: 0.3 }}>
              cloud_sync
            </span>
            <p style={{ marginTop: '12px', fontSize: '14px' }}>Your profile stored in Azure</p>
            <p style={{ fontSize: '12px', opacity: 0.7 }}>Upload your document to enhance</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProfileManager;